import { useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'

import { Box, Section } from '@factorialco/deprecated-design-system'
import { PermissionsGetManagePermissionPermissionsDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { PermissionGroupsLayout } from 'modules/permissions/components/PermissionGroupsLayout'
import DelegateList from 'modules/permissions/pages/settings/DelegatePermissionGroupPage/DelegateList'
import Footer from 'modules/permissions/pages/settings/Footer'
import { PermissionGroupContainerProps } from 'modules/permissions/pages/settings/PermissionGroupContainer'

const DelegatePermissionGroupPage = () => {
  useEffect(() => {
    track(trackingEvents.permissions.delegatePermissionsOpened)
  }, [])

  const { permissionGroup } = useOutletContext<PermissionGroupContainerProps>()
  const { data, loading } = useQuery(PermissionsGetManagePermissionPermissionsDocument, {
    variables: {
      permissionsGroupId: permissionGroup.attributes.id,
    },
  })

  const permissions = (data?.permissions.permissions ?? []).filter((permission) => {
    // FIXME: Add a 'verb' filter to the read DTO and get just the permisssions we need instead of
    // filtering here.
    return permission.verb === 'Permissions::Verbs::ManagePermission'
  })

  return (
    <ResponsivePage.Body loading={loading} error={null} showHeader={false}>
      <PermissionGroupsLayout />
      <Section.FullWidth
        illustration="lock-user"
        title={i18n.t('settings.permissions.group.permissions_delegate.title')}
        description={i18n.t('settings.permissions.group.permissions_delegate.description')}
      >
        <Box gap="s32">
          <DelegateList permissionGroup={permissionGroup} permissions={permissions} />
          <Footer />
        </Box>
      </Section.FullWidth>
    </ResponsivePage.Body>
  )
}

export default observer(DelegatePermissionGroupPage)
